import { InMemoryCache } from "@apollo/client";

import { possibleTypes } from "@shared/data/client";

const getCache = () =>
  new InMemoryCache({
    possibleTypes,
    typePolicies: {
      Query: {
        fields: {
          viewer: {
            merge: true,
          },
        },
      },
      Mutation: {
        fields: {
          viewer: {
            merge: true,
          },
          office: {
            merge: true,
          },
          store: {
            merge: true,
          },
        },
      },
      Viewer: {
        // This means the singleton Viewer's identity does not depend on any of its
        // fields (except for __typename), making the ID effectively constant.
        keyFields: [],
      },
      OfficeMutation: {
        keyFields: [],
      },
      StoreMutation: {
        keyFields: [],
      },
    },
  });

export { getCache };
